import {VStack} from "@styled-system/jsx";
import AccentCard from '~/routes/promotions.$promotionId/AccentCard';
import {formatUtcDate} from 'shared/utils/format';
import {css} from '@styled-system/css';

type DateCardProps = {
  title: string
  date: Date
}

const DateCard = ({title, date}: DateCardProps) => {
  return <AccentCard>
    <VStack whiteSpace="nowrap" alignItems="flex-start" color="blue.900" gap={0}>
      <p className={css({fontSize: 'sm', textAlpha: 'blue.900/60'})}>{title}</p>
      <p className={css({fontFamily: 'heading', fontWeight: 'semibold', textTransform: 'uppercase'})}>{formatUtcDate(date)}</p>
    </VStack>
  </AccentCard>
}

export default DateCard;
